import { render, staticRenderFns } from "./views.vue?vue&type=template&id=e490bcae&scoped=true&"
import script from "./views.vue?vue&type=script&lang=js&"
export * from "./views.vue?vue&type=script&lang=js&"
import style0 from "./views.vue?vue&type=style&index=0&id=e490bcae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e490bcae",
  null
  
)

export default component.exports